import { useI18n } from "@/i18n";

export const Marquee = () => {
  const { t } = useI18n();
  return (
    <div className="relative overflow-hidden border-y border-white/10 bg-[var(--navy)] py-7" data-testid="marquee">
      <div className="container-x flex flex-wrap items-center justify-center gap-x-10 gap-y-4">
        {t.marquee.map((message, index) => (
          <span key={message} className="flex min-w-0 items-center gap-3 font-display text-xl font-extrabold uppercase sm:text-2xl lg:text-3xl">
            <span className={index % 2 ? "text-outline" : "text-white"}>{message}</span>
            <span className="text-[var(--gold)]" aria-hidden="true">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
};